import React, { useContext } from "react";
import GlobalContext from "contexts/GlobalContext";
import { SIAAgenda, useTranslator } from "@sia/style-guide";
import cmsAdapter from "../../common/Adapters/CMSAdapter/CMSAdapter";
import Page from "pages/Page";
import { useHistory } from "react-router-dom";
const Agenda = () => {
  const { language } = useContext(GlobalContext);
  const history = useHistory();
  const translate = useTranslator();
  const getAgenda = async () => {
    const data = await cmsAdapter.fetchAgenda(language, translate);
    return data;
  };

  return (
    language && (
      <Page title={translate("header.app-switcher.agenda.name")}>
        <SIAAgenda lang={language} history={history} translate={(value, options) => translate(value, options)} getAgenda={getAgenda}></SIAAgenda>
      </Page>
    )
  );
};

export default Agenda;
